import { DEPOSITORY_SERVICE_NAME, DepositoryService } from '../../../../services/depository'
import { DEVICE_SERVICE_NAME, DeviceService } from '../../../../services/device'
import { OPERATOR_SERVICE_NAME, OPERATOR_DEPOSITORY_SERVICE_NAME, OperatorService, OperatorDepositoryService, OperatorTechnicalPermissionsService, OPERATOR_TECHNICAL_PERMISSIONS_SERVICE_NAME } from '../../../../services/operator'
import { $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, SystemService, SYSTEM_SERVICE_NAME } from '../../../../services/system'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../../services/user-session'

import { LocalDictionaryFactory } from '../../../api/api.module'

import { OperatorDetailsDirectiveController } from './operators-details.directive.controller'

//#region Asset Imports

import './operators-details.scss'
import * as TEMPLATE from './operators-details.tpl.html'

//#endregion


// Setup

export class OperatorDetailsDirective implements ng.IDirective {

    restrict = 'E'

    scope = {
        id: '='
    }

    controllerAs = '$ctrl'

    controller = [
        $SCOPE_SERVICE_NAME,
        $Q_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        'localDictionary',
        USER_SESSION_SERVICE_NAME,
        DEPOSITORY_SERVICE_NAME,
        DEVICE_SERVICE_NAME,
        OPERATOR_SERVICE_NAME,
        OPERATOR_DEPOSITORY_SERVICE_NAME,
        OPERATOR_TECHNICAL_PERMISSIONS_SERVICE_NAME,
        SYSTEM_SERVICE_NAME,
        (
            $scope: any,
            $q: ng.IQService,
            $timeout: ng.ITimeoutService,
            localDictionary: LocalDictionaryFactory,
            userSessionService: UserSessionService,
            depositoryService: DepositoryService,
            deviceService: DeviceService,
            operatorService: OperatorService,
            operatorDepositoryService: OperatorDepositoryService,
            operatorTechnicalPermmissionsService: OperatorTechnicalPermissionsService,
            systemService: SystemService
        ) => new OperatorDetailsDirectiveController(
            $scope,
            $q,
            $timeout,
            localDictionary,
            userSessionService,
            depositoryService,
            deviceService,
            operatorService,
            operatorDepositoryService,
            operatorTechnicalPermmissionsService,
            systemService,
            OperatorService.REFERENCE_TYPE,
            OperatorService.SIMAX_MODULE_NAME
        )]

    template = TEMPLATE
}

// Setup End